export const AUTHENTICATION_LOGIN_FAILED = "AUTHENTICATION_LOGIN_SUCCESS"
export const AUTHENTICATION_LOGIN_SUCCESS = "AUTHENTICATION_LOGIN_SUCCESS"

export const AUTHENTICATION_LOGOUT_FAILED = "AUTHENTICATION_LOGOUT_FAILED"
export const AUTHENTICATION_LOGOUT_SUCCESS = "AUTHENTICATION_LOGOUT_SUCCESS"

export const PROFILE_FAILED = "PROFILE_FAILED"
export const PROFILE_SUCCESS = "PROFILE_SUCCESS"

export const PROFILE_IMAGE_FAILED = "PROFILE_IMAGE_FAILED"
export const PROFILE_IMAGE_SUCCESS = "PROFILE_IMAGE_SUCCESS"

export const ADMIN_SESSION_REMOVE_SUCCESS = "ADMIN_SESSION_REMOVE_SUCCESS"